import colors from "../constants/colors";

export type CardVariant = "default" | "purple" | "blue" | "green" | "orange" | "yellow" | "teal" | "red";

export interface VariantColors {
  background: string;
  backgroundGradient: string;
  border: string;
  iconBg: string;
  iconColor: string;
  accentGlow: string;
}

/**
 * Centralized color variant system for consistent styling across components
 * Used by KLCollapsibleSection and can be extended to other components
 */
export const getVariantColors = (variant: CardVariant = "default"): VariantColors => {
  const variants: Record<CardVariant, VariantColors> = {
    default: {
      background: colors.GLASS_WHITE,
      backgroundGradient: "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.8) 100%)",
      border: colors.GLASS_BORDER,
      iconBg: colors.GRADIENT_PURPLE,
      iconColor: colors.WHITE,
      accentGlow: "rgba(116, 105, 182, 0.1)",
    },
    purple: {
      background: colors.GLASS_WHITE,
      backgroundGradient: "linear-gradient(135deg, rgba(116, 105, 182, 0.08) 0%, rgba(173, 136, 198, 0.05) 100%)",
      border: colors.PURPLE_LIGHT,
      iconBg: colors.GRADIENT_PURPLE,
      iconColor: colors.WHITE,
      accentGlow: "rgba(116, 105, 182, 0.15)",
    },
    blue: {
      background: colors.GLASS_WHITE,
      backgroundGradient: "linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(96, 165, 250, 0.05) 100%)",
      border: "rgba(59, 130, 246, 0.5)",
      iconBg: "linear-gradient(135deg, #3B82F6 0%, #60A5FA 100%)",
      iconColor: colors.WHITE,
      accentGlow: "rgba(59, 130, 246, 0.15)",
    },
    green: {
      background: colors.GLASS_WHITE,
      backgroundGradient: "linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(52, 211, 153, 0.05) 100%)",
      border: "rgba(16, 185, 129, 0.5)",
      iconBg: "linear-gradient(135deg, #10B981 0%, #34D399 100%)",
      iconColor: colors.WHITE,
      accentGlow: "rgba(16, 185, 129, 0.15)",
    },
    orange: {
      background: colors.GLASS_WHITE,
      backgroundGradient: "linear-gradient(135deg, rgba(251, 146, 60, 0.08) 0%, rgba(255, 165, 0, 0.05) 100%)",
      border: "rgba(251, 146, 60, 0.5)",
      iconBg: "linear-gradient(135deg, #FB923C 0%, #FFA500 100%)",
      iconColor: colors.WHITE,
      accentGlow: "rgba(251, 146, 60, 0.15)",
    },
    yellow: {
      background: colors.GLASS_WHITE,
      backgroundGradient: "linear-gradient(135deg, rgba(250, 204, 21, 0.08) 0%, rgba(253, 224, 71, 0.05) 100%)",
      border: "rgba(250, 204, 21, 0.5)",
      iconBg: "linear-gradient(135deg, #FACC15 0%, #FDE047 100%)",
      iconColor: colors.WHITE,
      accentGlow: "rgba(250, 204, 21, 0.15)",
    },
    teal: {
      background: colors.GLASS_WHITE,
      backgroundGradient: "linear-gradient(135deg, rgba(20, 184, 166, 0.08) 0%, rgba(45, 212, 191, 0.05) 100%)",
      border: "rgba(20, 184, 166, 0.5)",
      iconBg: "linear-gradient(135deg, #14B8A6 0%, #2DD4BF 100%)",
      iconColor: colors.WHITE,
      accentGlow: "rgba(20, 184, 166, 0.15)",
    },
    red: {
      background: colors.GLASS_WHITE,
      backgroundGradient: "linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(248, 113, 113, 0.05) 100%)",
      border: "rgba(239, 68, 68, 0.5)",
      iconBg: "linear-gradient(135deg, #EF4444 0%, #F87171 100%)",
      iconColor: colors.WHITE,
      accentGlow: "rgba(239, 68, 68, 0.15)",
    },
  };

  return variants[variant] || variants.default;
};
